import { isEqual } from "lodash";
import { useSelector } from "react-redux";
import { useRequest } from "redux-query-react";
import { concatRates } from "./ins-cashflow-common-functions";
import { CashflowFromJSON, getCashflowsFromTamodelParameters } from "api/admin/src";
import { useGetTaModelCommitment } from "store/administration/cashflow-forecasting/ta-model-editing/selectors";
const excelBlobType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
export const getDownloadFileConfig = (request, storeEntry, getFileFunc) => {
    const fileQueryConfig = getFileFunc(request, {
        transform: (response) => ({ [storeEntry]: { [request.id.toString()]: window.URL.createObjectURL(new Blob([response], { type: excelBlobType })) } }),
        update: {
            [storeEntry]: (prevValue, transformedValue) => ({ ...prevValue, ...transformedValue })
        }
    });
    const fileQueryHeaders = fileQueryConfig?.options?.headers;
    if (fileQueryHeaders) {
        fileQueryHeaders.requestBlob = "true";
    }
    return fileQueryConfig;
};
const getCashflowsFromTamodelParametersConfig = (request) => {
    const config = getCashflowsFromTamodelParameters(request);
    return {
        ...config,
        // Should be done differently in the generated code
        body: {},
        transform: (body) => ({ TACashflows: { [config.queryKey ?? ""]: body.map(CashflowFromJSON) } }),
        update: { TACashflows: (prevValue, transformedValue) => ({ ...prevValue, ...transformedValue }) }
    };
};
export const useGetTaModelCashflows = (request) => {
    const config = request ? getCashflowsFromTamodelParametersConfig(request) : null;
    const [queryState, refresh] = useRequest(config);
    const cashflows = useSelector((s) => s.entities.TACashflows[config?.queryKey ?? ""]);
    return [cashflows, queryState, refresh];
};
const getContributionRates = (hypotheticalRates, taModelRates, customModelRates) => {
    if (hypotheticalRates?.length) {
        return hypotheticalRates;
    }
    if (taModelRates?.length) {
        return taModelRates;
    }
    if (customModelRates?.length) {
        return customModelRates;
    }
    return [];
};
export const useGetTaModelParameters = (id) => {
    const hypotheticalParameters = useSelector((state) => state.administration.cashflowForecastingState.taModelEditingState.model[id]?.present.parameters, isEqual);
    const commitment = useGetTaModelCommitment(id);
    const taModel = useSelector((state) => state.entities.TAModels[id], isEqual);
    const customModel = useSelector((state) => state.entities.CashflowCustomModel[id], isEqual);
    if (hypotheticalParameters || taModel || customModel) {
        const taParams = customModel?.taParameters;
        const hypotheticalRates = hypotheticalParameters?.contributionRates;
        const taModelRates = concatRates(taModel?.contributionRates, taModel?.terminal);
        const customModelRates = concatRates(taParams?.contributionRates, taParams?.terminal);
        return {
            bow: hypotheticalParameters?.bow || taModel?.bow || taParams?.bow || 0,
            commitment: commitment || customModel?.commitment || 0,
            contributionRates: getContributionRates(hypotheticalRates, taModelRates, customModelRates),
            growthRate: hypotheticalParameters?.growthRate || taModel?.growthRate || taParams?.growthRate || 0,
            lifetime: hypotheticalParameters?.lifetime || taModel?.lifetime || taParams?.lifetime || 0,
            minDistributionRate: hypotheticalParameters?.minDistributionRate || taModel?.minDistributionRate || taParams?.minDistributionRate || 0
        };
    }
    return null;
};
